import React from 'react'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import DescIcon from 'components/atoms/SVGIcons/Desc'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Markdown from 'components/atoms/MarkdownContent'

import { string, bool } from 'prop-types'

const DescSection = ({ title, description, useIcon }) => (
  <div id="description" className="campus-desc-section">
    <SectionContainer
      marginTop={80}
      marginBottom={120}
    >
      <Container>
        <Row>
          <Col md="7">
            <div className="campus-desc-section__title">
              { useIcon && <DescIcon fill="#0FC3C4" height="32px" width="32px"/> }
              <SectionTitle title={title} align="left" />
            </div>
            <Markdown content={description}/>
          </Col>
        </Row>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .campus-desc-section {
          &__title {
            display: flex;
            align-items: center;
            :global(svg) {
              margin-right: 16px;
              margin-bottom: 24px;
            }
          }
        }
      `}
    </style>
  </div>
)

DescSection.propTypes = {
  title: string,
  description: string,
  useIcon: bool,
}

export default DescSection
